import React from 'react';

export const Globe = ({ width = 16, height = 16, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    className={className}
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.9987 2.66545C5.05318 2.66545 2.66536 5.05327 2.66536 7.99879C2.66536 10.9443 5.05318 13.3321 7.9987 13.3321C10.9442 13.3321 13.332 10.9443 13.332 7.99879C13.332 5.05327 10.9442 2.66545 7.9987 2.66545ZM1.33203 7.99879C1.33203 4.31689 4.3168 1.33212 7.9987 1.33212C11.6806 1.33212 14.6654 4.31689 14.6654 7.99879C14.6654 11.6807 11.6806 14.6655 7.9987 14.6655C4.3168 14.6655 1.33203 11.6807 1.33203 7.99879Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.73203 5.99879C1.73203 5.6306 2.03051 5.33212 2.3987 5.33212H13.5987C13.9669 5.33212 14.2654 5.6306 14.2654 5.99879C14.2654 6.36698 13.9669 6.66545 13.5987 6.66545H2.3987C2.03051 6.66545 1.73203 6.36698 1.73203 5.99879Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.73203 9.99879C1.73203 9.6306 2.03051 9.33212 2.3987 9.33212H13.5987C13.9669 9.33212 14.2654 9.6306 14.2654 9.99879C14.2654 10.367 13.9669 10.6655 13.5987 10.6655H2.3987C2.03051 10.6655 1.73203 10.367 1.73203 9.99879Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.01831 1.43321C8.33067 1.62813 8.42587 2.03937 8.23094 2.35173C7.1739 4.0456 6.6135 6.00215 6.6135 7.99879C6.6135 9.99542 7.1739 11.952 8.23094 13.6458C8.42587 13.9582 8.33067 14.3694 8.01831 14.5644C7.70595 14.7593 7.29471 14.6641 7.09979 14.3517C5.91062 12.4461 5.28017 10.245 5.28017 7.99879C5.28017 5.75257 5.91062 3.55145 7.09979 1.64585C7.29471 1.33349 7.70595 1.23829 8.01831 1.43321Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.97909 1.43321C8.29145 1.23829 8.70268 1.33349 8.89761 1.64585C10.0868 3.55145 10.7172 5.75257 10.7172 7.99879C10.7172 10.245 10.0868 12.4461 8.89761 14.3517C8.70268 14.6641 8.29145 14.7593 7.97909 14.5644C7.66673 14.3694 7.57153 13.9582 7.76645 13.6458C8.8235 11.952 9.38389 9.99542 9.38389 7.99879C9.38389 6.00215 8.8235 4.0456 7.76645 2.35173C7.57153 2.03937 7.66673 1.62813 7.97909 1.43321Z"
      fill="currentColor"
    />
  </svg>
);

export default Globe;
